import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthAccessService } from "./auth-access.service";

@Injectable({
  providedIn: "root",
})
export class RouteChildGuard implements CanActivateChild {
  constructor(private authAccessService: AuthAccessService) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.authAccessService.canAccess(childRoute, state);
  }
}
